<template>
  <!-- 话题管理 -->
  <div class="">
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      ref="table"
      rowKey="categoryId"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"

      :deleteParam="deleteParam"
      :rowSelection="true"
    >
      <template slot="opt_t" slot-scope="{row}">
        <a-switch v-hasPermi="['']" @change="changeStatus(row)" :checked="Number(row.recommend) ? true : false"/>
      </template>
      <template slot="opt_status" slot-scope="{row}">
        <div style="display: flex; align-items: center">
          <span class="circle-dot" :class="statusColor[row.status] + '-bg'"></span>
          <span>{{statusObj[row.status] }}</span>
        </div>
      </template>
      <template slot="opt_c" slot-scope="{row}">
        <a-tooltip :title="row.describe">
          <div class="feed-over-text">{{row.describe}}</div>
        </a-tooltip>
      </template>
    </x-tabula>
    <add ref='model' @updateTable = 'updateTable'></add>

  </div>
</template>

<script>
import { empty } from 'ant-design-vue-admin-x';
import add from './add.vue';
export default {
  name: 'topicManage',
  components: {
    add
  },
  data () {
    return {
      visible: false,
      rowData: {},
      searchList: [
        {
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '话题名',
          props: ['keywords']
        }, {
          inputType: 'select',
          options: [
            { value: '1', label: '启用' },
            { value: '0', label: '禁用' }
          ],
          handle: '',
          placeholder: '状态',
          props: ['status']
        }, {
          inputType: 'select',
          options: [
            { value: '1', label: '是' },
            { value: '0', label: '否' }
          ],
          handle: '',
          placeholder: '是否推荐',
          props: ['recommend']
        },
        {
          options: [],
          handle: '',
          placeholder: ['创建时间', '创建时间'],
          options: [],
          inputType: 'datePick',
          props: ['createDate']
        }
      ],
      tableOptList: [
        {
          text: '新增',
          icon: 'plus',
          permi: ['community:housekeepCircleCategory:add'],
          handle: () => { this.$refs.model.show(); }
        },
        { text: '删除', icon: 'close', disabled: true, permi: ['community:housekeepCircleCategory:remove'] }
      ],
      rowOptList: [
        {
          text: '修改',
          handle: row => { this.$refs.model.show(row); },
          permi: ['community:housekeepCircleCategory:edit']
        },
        {
          customRender: true,
          rowOptText: row => row.status == 1 ? '禁用' : '启用',
          handle: record => this.switchHandle(record),
          permi: ['community:housekeepCircleCategory:change']
        }
      ],
      columns: [
        {
          title: '话题',
          dataIndex: 'title',
          align: '',
          width: ''
        },
        {
          title: '描述',
          dataIndex: 'describe',
          align: '',
          width: '',
          scopedSlots: {customRender: 'c'}
        },
        {
          title: '浏览次数',
          dataIndex: 'viewCount',
          align: '',
          width: ''
        },
        {
          title: '排序',
          dataIndex: 'sort',
          align: '',
          width: ''
        },
        {title: '推荐', dataIndex: 'recommend', align: '', scopedSlots: {customRender: 't'}},
        {title: '状态', dataIndex: 'status', align: '', scopedSlots: {customRender: 'status'}},
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: '',
          width: ''
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: '',
          width: '',
          scopedSlots: { customRender: 'action' }
        }
      ],
      statusObj: ['禁用', '启用'],
      statusColor: ['info', 'success'],
      dataSource: [],
      searchParams: {
        keywords: undefined,
        recommend: undefined,
        createDate: undefined,
        status: undefined
      },
      listApi: {
        url: '/housekeep/circles/category',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {
        url: '/housekeep/circles/category/',
        title: '该话题',
        key: 'title'
        // resHandle: '' // 执行完删除的回调方法
      }
    };
  },
  created () {

  },
  methods: {
    switchHandle (row) {
      let status = row.status == 1 ? 0 : 1;
      this.$put({
        url: `/housekeep/circles/category/change/${row.categoryId}`,
        params: {
          status
        }
      }).then((res) => {
        this.$message.success(res.msg);
        this.$refs.table.getTableList();
      });
    },
    /* 切换状态 */
    changeStatus (row) {
      let recommend = row.recommend == 1 ? 0 : 1;
      this.$put({
        url: `/housekeep/circles/category/${row.categoryId}`,
        params: {
          recommend
        }
      }).then((res) => {
        this.$message.success(res.msg);
        this.$refs.table.getTableList();
      });
    },
    updateTable (res) {
      if (res && res.code == 200) {
        this.$message.success(res.msg);
      }
      this.$refs.table.getTableList();
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
